import { render, staticRenderFns } from "./ResourceCenterEdit.vue?vue&type=template&id=0c13d278&scoped=true"
import script from "./ResourceCenterEdit.vue?vue&type=script&lang=js"
export * from "./ResourceCenterEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c13d278",
  null
  
)

export default component.exports